// @flow
import { handleActions } from 'redux-actions';
import { SET_LANDING_TAB, SET_LANDING_TAB_IN_SAME_BROWSER } from './constants';

export type State = {
    isLandingTab: boolean | undefined,
    isLandingTabInSameBrowser: boolean | null,
};

const initialState: State = {
    isLandingTab: null,
    isLandingTabInSameBrowser: null,
};

const reducer = handleActions({
    [SET_LANDING_TAB]: (state: State, { payload }: {
        payload: {}
    }) => ({ ...state, isLandingTab: payload.isLandingTab }),
    [SET_LANDING_TAB_IN_SAME_BROWSER]: (state: State, { payload }: {
        payload: {}
    }) => ({ ...state, isLandingTabInSameBrowser: payload.isLandingTabInSameBrowser }),
}, initialState);

export default reducer;
